import { NotFoundPage } from "apps/commons/components/NotFoundPage";

export default NotFoundPage;
